/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M4.75 4.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5h-8ZM17.5303 11.4697a.75.75 0 0 1 0 1.0606l-3.9646 3.9647a.8.8 0 0 1-1.1314 0l-1.9646-1.9647a.75.75 0 0 1 0-1.0606.75.75 0 0 1 1.0606 0L13 14.9393l3.4697-3.4696a.75.75 0 0 1 1.0606 0Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.75 0C.7835 0 0 .7835 0 1.75v20.5C0 23.2165.7835 24 1.75 24h14c.9665 0 1.75-.7835 1.75-1.75v-2.6367a6.75 6.75 0 0 0 .4704-.3451l4.5138 4.2763a.7501.7501 0 0 0 1.0316-1.089l-4.4859-4.2497C19.95 17.0522 20.5 15.5903 20.5 14c0-2.3403-1.191-4.4024-3-5.6133V1.75C17.5.7835 16.7165 0 15.75 0h-14ZM16 7.634V1.75a.25.25 0 0 0-.25-.25h-14a.25.25 0 0 0-.25.25v20.5a.25.25 0 0 0 .25.25h14a.25.25 0 0 0 .25-.25v-1.8841a6.738 6.738 0 0 1-2.25.3841c-3.1227 0-5.7501-2.1204-6.521-5H4.75a.75.75 0 0 1 0-1.5h2.2545A6.8735 6.8735 0 0 1 7 14c0-1.1782.3019-2.2859.8325-3.25H4.75a.75.75 0 0 1 0-1.5h4a.7513.7513 0 0 1 .1822.0223C10.157 8.0243 11.863 7.25 13.75 7.25c.7889 0 1.5462.1353 2.25.384ZM13.75 8.75c-2.8995 0-5.25 2.3505-5.25 5.25s2.3505 5.25 5.25 5.25S19 16.8995 19 14s-2.3505-5.25-5.25-5.25Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'AuditLogs'
);
